module.exports = __webpack_public_path__ + "img/Pan_Maleri-under-Nyrealisme-og-nobelpris.19f82230.jpg";